const asArray = (v) => (Array.isArray(v) ? v : v ? [v] : [])

export const ordnanceOptions = (source, weapons) =>
    asArray(source?.OrdnanceKeys)
        .map((key) => weapons.find((w) => w.Key === key))
        .filter(Boolean)

const withOrdnance = (weapon, ordnanceKey, weapons) => {
    const ordnance = ordnanceKey && weapons.find((w) => w.Key === ordnanceKey)
    if (!weapon || !ordnance) { return weapon }

    const qualities = [...asArray(weapon.Qualities)]
    asArray(ordnance.Qualities).forEach((q) => {
        if (!qualities.some((existing) => existing.Key === q.Key)) { qualities.push(q) }
    })

    return {
        ...weapon,
        Damage: ordnance.Damage,
        Crit: ordnance.Crit,
        Range: ordnance.Range,
        RangeValue: ordnance.RangeValue,
        SkillKey: weapon.SkillKey || ordnance.SkillKey,
        Qualities: qualities,
        BaseMods: [...asArray(weapon.BaseMods), ...asArray(ordnance.BaseMods)],
        LoadedOrdnanceName: ordnance.Name,
    }
}

export default withOrdnance
